import template from './employee_employment_listing_report.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportEmployeeEmploymentListingReportViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.employee_employment_listing_report = ko.observableArray('');
		this.employee_document_types = ko.observableArray('');
		this.current_department_id = ko.observable();
		this.selected_department = ko.observable();

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
			{
				this.current_department_id(newValue.department_id);
				this.page.updateData();
			}
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});
	};
}

class ReportEmployeeEmploymentListing 
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportEmployeeEmploymentListingReportViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeeEmploymentListingReport'))
			return;

		document.title = tr('Employee Employment Listing Report');
		window.current_page_title(tr('Employee Employment Listing Report'));

		let res = await Grape.fetches.getJSON('/api/record', { 
			table: 'employee_document_types',
			limit: 1000000,
			sortfield: 'type',
			sortorder: 'ASC'
		});

		if (res)
			this.viewModel.employee_document_types(res.records);
	}

	updateData()
	{
		if (this.viewModel.current_department_id() != null)
			this.updateReportData();
	}

	async updateReportData()
	{
		this.viewModel.employee_employment_listing_report('');
		this.viewModel.loader(true);
		
		let res = await Grape.fetches.getJSON('/api/record', {
			schema: 'savanna',
			table: 'v_employee_employment_listing',
			limit: 1000000,
			filter: [{ value: this.viewModel.current_department_id(), op: '=', field: 'department_id' }]
		});

		if (res)
		{
			this.viewModel.employee_employment_listing_report(res.records);
			this.viewModel.loader(false);
		}
	}

	show_report_help()
	{
		Grape.dialog.open('EmployeeEmploymentListingReportHelp', { 'employee_id': this.bindings.id }, {});
	}

	async downLoadClicked(v, e)
	{
		let csv_string = await Utils.table_to_csv(document.getElementById('employee_employment_listing_report'));
		if (csv_string === null || csv_string === undefined || csv_string === '')
			return;

		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'employee_employment_listing_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

export default {
	route: '[/]report/employee_employment_listing_report',
	page_class: ReportEmployeeEmploymentListing,
	template: template,
	template_filename: 'translation/employee_employment_listing_report'
};
